import  { createContext } from 'react';
import { AnalyticsAction, AnalyticsState } from '../types';

interface ContextProps {
  state: AnalyticsState;
  dispatch: (action: AnalyticsAction) => void;
}

export const AnalyticsContext = createContext({} as ContextProps);
